import contact from './contact';
import marketo from './marketoform';
import landing from './templateLandingPage';

export default {
  init() {
    contact.handleContactForm()
    marketo.dummyData()
    marketo.handleMarketoForm()
    marketo.prepopulateMarketoForm()
    this.byPassGatedForm()
    this.downloadPDF()
    this.resizeIframe()
    landing.parallaxImage();
    landing.slider();
    landing.appendUTMQueryParamsToCtas();
    landing.playVideoOnScroll();
    if (contact.checkStoredData()) {
      $('#gated-form-wrapper').show()
    } else {
      $('#bypass-gated-form').show()
    }
  },
  byPassGatedForm() {
    $('form#bypass-gated-form').submit(function (e) {
      e.preventDefault();
      contact.sendPostSuccessParam(location.href + '?stage=2')
    })
  },
  downloadPDF(){
    setTimeout(function(){
      $('article.pre').hide();
      $('article.post').show();
    }, 1800)
  },
  resizeIframe() {
    $('.tool').find('iframe').on('load', function() {
      $(this).height($('iframe').contents().height() + 'px');
    });
    $(window).on('resize', function() {
      $('.tool').find('iframe').height('auto').height($('iframe').contents().height() + 'px');
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};


// WEBPACK FOOTER //
// ./scripts/routes/singleResource.js